import { FileText, Image as ImgIcon, FileSpreadsheet } from 'lucide-react'
import { chatService } from '../../services/chatService'
import { toast } from '../../stores/uiStore'

const fmtSize = (b) => (!b ? '' : b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`)
const isImg = (ct, n) => (ct || '').startsWith('image/') || /\.(png|jpe?g|gif|webp|svg)$/i.test(n || '')
const isXls = (n) => /\.(xlsx?|csv)$/i.test(n || '')

// Mesaj içi dosya chip'i (görseldeki Sohar_Steel_BOM.xlsx satırı)
export default function AttachmentChip({ att, company, onOpen }) {
  // onOpen verilmezse (eski kullanım) dosyayı indirmeye düş
  const open = async () => {
    if (onOpen) return onOpen()
    try {
      const blob = await chatService.fetchAttachmentBlob(company, att.id)
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url; a.download = att.file_name || 'dosya'
      document.body.appendChild(a); a.click(); a.remove()
      setTimeout(() => URL.revokeObjectURL(url), 60000)
    } catch (e) { toast.error('Hata', e.response?.data?.detail || e.message) }
  }
  const Icon = isImg(att.content_type, att.file_name) ? ImgIcon : isXls(att.file_name) ? FileSpreadsheet : FileText
  const color = isXls(att.file_name) ? 'text-emerald-600' : isImg(att.content_type, att.file_name) ? 'text-blue-600' : 'text-gray-500'
  return (
    <button onClick={open}
      className="inline-flex items-center gap-1.5 px-2 py-1 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 max-w-[280px]">
      <Icon size={14} className={`${color} shrink-0`} />
      <span className="text-[12px] text-gray-800 truncate underline decoration-gray-300">{att.file_name}</span>
      {att.size_bytes ? <span className="text-[10px] text-gray-400 shrink-0">{fmtSize(att.size_bytes)}</span> : null}
    </button>
  )
}
